import * as React from 'react';
import { clsx } from 'clsx';
import { generateDataTestId } from '../../../internal/utils';
import { hasCounter } from './utils';
import { Counter } from '../../../internal/components/Counter';
import styles from './ChipButton.module.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ChipButton = _ref => {
  let {
    size = 'M',
    icon,
    iconPosition = 'right',
    leftIcon,
    counter,
    counterMaxLength,
    checked,
    invalid,
    disabled,
    tabIndex = 0,
    dataTestId,
    text,
    onClick
  } = _ref;
  const chipRef = React.useRef(null);
  const handleClick = event => {
    var _chipRef$current;
    onClick(!checked, event);
    (_chipRef$current = chipRef.current) === null || _chipRef$current === void 0 || _chipRef$current.blur();
  };
  const handleKeyDown = event => {
    if (event.code === 'Space') {
      onClick(!checked);
    }
  };
  const counterExists = hasCounter(counter);
  const disableButton = disabled || counter === 0;
  return /*#__PURE__*/_jsxs("div", {
    className: clsx(styles['chip-button'], {
      [styles['chip-button--checked']]: checked,
      [styles['chip-button--disabled']]: disableButton,
      [styles['chip-button--invalid']]: invalid,
      [styles['chip-button--only-icon']]: !text && icon,
      [styles['chip-button--small']]: size === 'S',
      [styles['chip-button--medium']]: size === 'M'
    }),
    onClick: handleClick,
    "data-testid": dataTestId,
    tabIndex: disableButton ? -1 : tabIndex,
    onKeyDown: handleKeyDown,
    ref: chipRef,
    role: "button",
    "aria-selected": checked,
    children: [text && /*#__PURE__*/_jsx("span", {
      className: styles['text'],
      "data-testid": generateDataTestId(dataTestId, ['text']),
      children: text
    }), icon && /*#__PURE__*/_jsx("span", {
      className: clsx(styles['icon'], {
        [styles['icon--left']]: iconPosition === 'left' && !leftIcon
      }),
      "data-testid": generateDataTestId(dataTestId, ['icon']),
      children: icon
    }), counterExists && /*#__PURE__*/_jsx(Counter, {
      counter: counter,
      counterMaxLength: counterMaxLength,
      dataTestId: generateDataTestId(dataTestId, ['counter'])
    }), leftIcon && /*#__PURE__*/_jsx("span", {
      className: clsx(styles['icon'], styles['icon--left']),
      "data-testid": generateDataTestId(dataTestId, ['icon-left']),
      children: leftIcon
    })]
  });
};